import { isValidCNPJ } from '@brazilian-utils/brazilian-utils';
import { DateTime } from 'luxon';

export const isCnpj = (value) => isValidCNPJ(value);

// w3c regex
// eslint-disable-next-line
export const isEmail = (value) =>
  /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(value);

export const isFilled = (value) => {
  if (value === undefined) {
    return false;
  }

  return !!value.trim();
};

export const hasLessSixChars = (value) => isFilled(value) && value.length >= 6;

export const isPhone = (value) => /^\([1-9]{2}\)\s[0-9]{8,9}$/.test(value);

export const isPostalCode = (value) => /^\d{5}-\d{3}?$/.test(value);

export const isDate = (value, lang = 'en') => {
  try {
    const format = {
      'pt-br': /^\d{1,2}\/\d{1,2}\/\d{4}$/,
      en: /^\d{4}\/\d{1,2}\/\d{1,2}$/,
    };

    const parsedLang = lang.toLocaleLowerCase();
    const viewFormat = format[parsedLang] || format.en;

    if (!viewFormat.test(value)) {
      return false;
    }

    const [dayOrYear, month, yearOrDay] = value.split('/');
    const obj = {
      en: {
        month,
        day: yearOrDay,
        year: dayOrYear,
      },
      'pt-br': {
        month,
        day: dayOrYear,
        year: yearOrDay,
      },
    };

    const dateObj = obj[parsedLang] || obj.en;

    return DateTime.fromObject(dateObj).isValid;
  } catch {
    return false;
  }
};
